<template>
  <a
    :href="url"
    :target="blank ? '_blank' : '_self'"
    rel="nofollow"
    v-bind="$attrs"
  >
    <slot>{{ text }}</slot>
  </a>
</template>

<script lang="ts">

export default defineComponent({
  name: 'ExternalLink',
  props: {
    text: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      required: true,
    },
    blank: {
      type: Boolean,
      default: false,
    },
  },
});

</script>
